<div class="mx-4 my-4 pb-5 modal-main">
  <div class="header pt-3 mt-1 mb-1 row pb-4 align-items-center">
    <div class="col d-flex justify-content-end">
      <img src="/assets/svg/ico-hamburger-close.svg" class="cross-button pointer-cursor" (click)="closeDialog()" />
    </div>

    <div class="w-100 d-flex flex-row justify-content-center align-items-center icon-style">
      <img src="/assets/svg/ico-completed-check.svg" alt="completed account setting" />
    </div>

    <div
      class="modal-title w-100 d-flex flex-row justify-content-center align-items-center pb-5 completed position-relative">
      <p>{{ SuccessMessage }}</p>
    </div>
  </div>
  <div class="header pt-3 mt-1 mb-1 row pb-4 align-items-center">
    <button class="btn btn-danger px-3 w-100 save-btn" type="button" (click)="closeDialog()">
      {{ 'DONE' | translate }}
    </button>
  </div>
</div>